import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { StatusService } from '../status.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-master-stage-detail',
  templateUrl: './stage_details.component.html',
  styleUrls: ['./stage_details.component.css']
})
export class MasterStageDetailComponent implements OnInit {
  guid: string = '';
  data: any;
  stageDetails: any[] = [];
  master: any;
  accountName: any;
  accountStages: any[];
  account_selected: string;
  accountactive: boolean;
  accountdetails: any;
  processes: any;

  constructor(
    private route: ActivatedRoute,
    private statusService: StatusService,
    private location: Location
  ) {}

filteredStages: any[] = [];       
pagedStages: any[] = [];     
pageSize: number = 10;
searchTerm: string = "";
currentPage: number = 1;
totalPages: number = 1;

  ngOnInit(): void {
    this.load();
  }

  load(){
        this.route.queryParams.subscribe(params => {
      this.guid = params['guid'];
      this.statusService.getStageDetail(this.guid).subscribe({
        next: (response) => {
          this.data = response.data;
          this.stageDetails = response.data.process?.stages ?? [];
          this.processes = (this.stageDetails as any)['PREPROCESSING'] || [];
          console.log(this.stageDetails);
          this.accountStages = Object.entries(this.stageDetails || {})
          .filter(([key]) => key !== "PREPROCESSING")
          .map(([key, value]) => ({ accountId: key, ...value }));
          this.master = response.data.process?.master_account_id || 'N/A';
          this.accountName = response.data.process?.master_account_name || '';
           this.filteredStages = [...this.accountStages];
  this.updatePagination();
        },
        error: (err) => {
          console.error('Error fetching stage details:', err);
        }
      });
    });
  }
searchAccount() {
  if (this.searchTerm.trim() === "") {
    this.filteredStages = [...this.accountStages];
  } else {
    this.filteredStages = this.accountStages.filter(acc =>
      acc.accountId.includes(this.searchTerm.trim())
    );
  }
  this.currentPage = 1;
  this.updatePagination();
}

updatePagination() {
  this.totalPages = Math.ceil(this.filteredStages.length / this.pageSize);
  const startIndex = (this.currentPage - 1) * this.pageSize;
  const endIndex = startIndex + this.pageSize;
  this.pagedStages = this.filteredStages.slice(startIndex, endIndex);
}

setPage(page: number) {
  if (page >= 1 && page <= this.totalPages) {
    this.currentPage = page;
    this.updatePagination();
  }
}

onAccountClick(accountId: string): void {
  this.accountactive = true;
  this.account_selected = accountId;
  this.accountdetails = this.accountStages.find(acc => acc.accountId === accountId);
  console.log(typeof(this.accountdetails))
  console.log('Clicked Account:', this.accountdetails);
}

  goBack(): void {
    this.location.back();
  }

  getStatusClass(status: string): string {
    switch (status) {
      case 'SUCCESS': return 'text-success fw-bold';
      case 'FAILED': return 'text-danger fw-bold';
      case 'IN_PROGRESS': return 'text-warning fw-bold';
      default: return 'text-muted';
    }
  }
}